import { Dialog } from "@progress/kendo-react-dialogs";
import React from "react";
import "./employee_concern.css";
import { Checkbox, RadioButton } from "@progress/kendo-react-inputs";
import DatePicker from "react-datepicker";
import { CustomDatePicker } from "../../../components/custom/datepicker";
import moment from "moment";
import { statusConfig } from "./configData";
import { ComboBox, DropDownList } from "@progress/kendo-react-dropdowns";

export const Filter = (props) => {
  const checkDateVali = (type) => {
    if (type === "updatedDate") {
      if (
        props.filterValue.updated_on_start === "" ||
        props.filterValue.updated_on_end === ""
      ) {
        return (
          <div className="Promotion_create_error_text">
            In date range, From date, To date should not be empty!
          </div>
        );
      } else if (
        new Date(props.filterValue.updated_on_start) >
        new Date(props.filterValue.updated_on_end)
      ) {
        return (
          <div className="Promotion_create_error_text">
            In date range, From date should not be later than To date!
          </div>
        );
      } else {
        return "";
      }
    }

    if (type === "createdDate") {
      if (
        props.filterValue.created_on_start === "" ||
        props.filterValue.created_on_end === ""
      ) {
        return (
          <div className="Promotion_create_error_text">
            In date range, From date, To date should not be empty!;
          </div>
        );
      } else if (
        new Date(props.filterValue.created_on_start) >
        new Date(props.filterValue.created_on_end)
      ) {
        return (
          <div className="Promotion_create_error_text">
            In date range, From date should not be later than To date!;
          </div>
        );
      } else {
        return "";
      }
    }
  };

  return (
    <Dialog width={395} height={"100%"} className="employee_concern_filter_dialog">
      <div className="employee_concern_filter_main_box">
        <div style={{ position: "relative" }}>
          <div
            className="employee_concern_filter_cross_icon"
            onClick={() => props.setShowFilter(false)}
          >
            <span class="k-icon k-font-icon k-i-close k-icon-xl" />
          </div>
        </div>
        <div className="employee_concern_filter_header_box">
          <div className="employee_concern_filter_header_title">Filter</div>
          <div
            className="employee_concern_filter_header_clear_filter"
            onClick={props.filterClearAction}
          >
            Clear Filter
          </div>
        </div>
        <div className="employee_concern_filter_detail_main_box">

          <div className="employee_concern_filter_detail_date_box">
            <div className="employee_concern_filter_detail_title">Created On</div>
            <div className="employee_concern_filter_radio_button_main_box">
              <div className="employee_concern_filter_radio_main_box">
                <RadioButton
                  className="Promotion_filter_Radio"
                  name="createdOn"
                  value="all"
                  key="all"
                  checked={props.filterValue.createdDate === "all"}
                  onChange={(e) => {
                    props.setFilterValue({
                      ...props.filterValue,
                      createdDate: "all",
                    });
                  }}
                />
                All dates
              </div>
              <div className="employee_concern_filter_radio_main_box">
                <RadioButton
                  className="Promotion_filter_Radio"
                  name="createdOn"
                  value="date"
                  key="date"
                  checked={props.filterValue.createdDate === "date"}
                  onChange={(e) => {
                    props.setFilterValue({
                      ...props.filterValue,
                      createdDate: "date",
                    });
                  }}
                />
                Date Range
              </div>
            </div>
            {props.filterValue.createdDate === "date" && (
              <div className="employee_concern_filter_detail_date">
                <div className="employee_concern_filter_detail_date_child">
                  <div>From</div>
                  <DatePicker
                    dateFormatCalendar="MMMM"
                    customInput={<CustomDatePicker />}
                    // minDate={new Date()}
                    selected={
                      props.filterValue.created_on_start !== ""
                        ? new Date(props.filterValue.created_on_start)
                        : ""
                    }
                    onChange={(e) =>
                      props.setFilterValue({
                        ...props.filterValue,
                        created_on_start: moment(e).format("YYYY-MM-DD"),
                      })
                    }
                  />
                </div>
                <div className="employee_concern_filter_detail_date_child">
                  <div>To</div>
                  <DatePicker
                    dateFormatCalendar="MMMM"
                    customInput={<CustomDatePicker />}
                    // minDate={new Date()}
                    selected={
                      props.filterValue.created_on_end !== ""
                        ? new Date(props.filterValue.created_on_end)
                        : ""
                    }
                    onChange={(e) =>
                      props.setFilterValue({
                        ...props.filterValue,
                        created_on_end: moment(e).format("YYYY-MM-DD"),
                      })
                    }
                  />
                </div>
              </div>
            )}
            {props.filterValue.createdDate === "date"
              ? checkDateVali("createdDate")
              : ""}
          </div>
          <div className="employee_concern_filter_detail_date_box">
            <div className="employee_concern_filter_detail_title">Updated On</div>
            <div className="employee_concern_filter_radio_button_main_box">
              <div className="employee_concern_filter_radio_main_box">
                <RadioButton
                  className="Promotion_filter_Radio"
                  name="updatedOn"
                  value="all"
                  key="all"
                  checked={props.filterValue.updatedDate === "all"}
                  onChange={(e) => {
                    props.setFilterValue({
                      ...props.filterValue,
                      updatedDate: "all",
                    });
                  }}
                />
                All dates
              </div>
              <div className="employee_concern_filter_radio_main_box">
                <RadioButton
                  className="Promotion_filter_Radio"
                  name="updatedOn"
                  value="date"
                  key="date"
                  checked={props.filterValue.updatedDate === "date"}
                  onChange={(e) => {
                    props.setFilterValue({
                      ...props.filterValue,
                      updatedDate: "date",
                    });
                  }}
                />
                Date Range
              </div>
            </div>
            {props.filterValue.updatedDate === "date" && (
              <div className="employee_concern_filter_detail_date">
                <div className="employee_concern_filter_detail_date_child">
                  <div>From</div>
                  <DatePicker
                    dateFormatCalendar="MMMM"
                    customInput={<CustomDatePicker />}
                    // minDate={new Date()}
                    selected={
                      props.filterValue.updated_on_start !== ""
                        ? new Date(props.filterValue.updated_on_start)
                        : ""
                    }
                    onChange={(e) =>
                      props.setFilterValue({
                        ...props.filterValue,
                        updated_on_start: moment(e).format("YYYY-MM-DD"),
                      })
                    }
                  />
                </div>
                <div className="employee_concern_filter_detail_date_child">
                  <div>To</div>
                  <DatePicker
                    dateFormatCalendar="MMMM"
                    customInput={<CustomDatePicker />}
                    // minDate={new Date()}
                    selected={
                      props.filterValue.updated_on_end !== ""
                        ? new Date(props.filterValue.updated_on_end)
                        : ""
                    }
                    onChange={(e) =>
                      props.setFilterValue({
                        ...props.filterValue,
                        updated_on_end: moment(e).format("YYYY-MM-DD"),
                      })
                    }
                  />
                </div>
              </div>
            )}
            {props.filterValue.updatedDate === "date"
              ? checkDateVali("updatedDate")
              : ""}
          </div>
           <div className="employee_concern_filter_check_box_main_box">
            <div className="employee_concern_filter_detail_title">What is Your Concern Related to</div>
            <DropDownList
              data={props.relatedToList}
              value={props.filterValue.related_to || 'Select'}
              size={"large"}
              onChange={(e) => {
                props.setFilterValue({
                  ...props.filterValue,
                  related_to: e.target.value,
                });

              }}
              iconColor="#73007D"
              iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"
            />
          </div>
          <div className="employee_concern_filter_check_box_main_box">
            <div className="employee_concern_filter_detail_title">Status</div>
            {statusConfig.map((i) => (
              <div key={i} className="Pormotions_filter_check_box_item">
                <Checkbox
                  style={{ border: "1px solid #CCC" }}
                  checked={
                    props.filterValue.status.find((l) => l === i) ? true : false
                  }
                  onClick={(e) => {
                    const find = props.filterValue.status.find((l) => l === i);
                    if (find) {
                      const filter = props.filterValue.status.filter(
                        (l) => l !== i
                      );
                      props.setFilterValue({
                        ...props.filterValue,
                        status: filter,
                      });
                    } else {
                      props.setFilterValue({
                        ...props.filterValue,
                        status: [...props.filterValue.status, i],
                      });
                    }
                  }}
                />
                {i}
              </div>
            ))}
          </div>

        </div>
        <div className="employee_concern_filter_footer_main_box">
          <div
            className="employee_concern_filter_footer_cancel"
            onClick={() => props.setShowFilter(false)}
          >
            Cancel
          </div>
          <div
            className="employee_concern_filter_footer_submit"
            onClick={props.FilterAction}
          >
            Submit
          </div>
        </div>
      </div>
    </Dialog>
  );
};
